module.exports = __webpack_public_path__ + "img/m_mystery_box.50f987a7.png";